export enum PROJECTS {
  /*
   * Flujo cuentas de ahorro (MF-STEPS)
   */
  ACC = 'ACC',
  /*
   * Flujo prestamo de libre disposicion (MF-LOAN)
   */
  PLD = 'PLD',
  /*
   * Flujo deposito a plazo fijo (MF-FTD)
   */
  FTD = 'FTD',

  ENROLLMENT = 'ENROLLMENT',

  BIOMETRICS = 'BIOMETRICS',

  SHELL = 'SHELL'
}
